"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePhoto = ProfilePhoto;
var jsx_runtime_1 = require("react/jsx-runtime");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var hooks_1 = require("../../store/hooks");
function ProfilePhoto(props) {
    var photoUrl = props.photoUrl, fullName = props.fullName, initials = props.initials;
    var dispatch = (0, hooks_1.useAppDispatch)();
    if (!photoUrl) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center size-12 rounded-md bg-primary-navy text-white text-sm font-semibold shrink-0", "aria-label": fullName, children: initials }));
    }
    var handleOpen = function () {
        void dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Profile Picture",
            contentMaxWidth: "max-w-lg",
            isDismissable: true,
            content: (0, jsx_runtime_1.jsx)("img", { src: photoUrl, alt: fullName, className: "w-full rounded-md object-contain" }),
        }));
    };
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleOpen, "aria-label": "View ".concat(fullName, "'s profile picture"), className: "shrink-0 rounded-md cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-navy", children: (0, jsx_runtime_1.jsx)("img", { src: photoUrl, alt: fullName, className: "size-12 rounded-md object-cover hover:opacity-90 transition-opacity" }) }));
}
